<template>
  <div style="display: flex;flex-direction: column;width: 100%;align-items: center;">
    <span class="titleMent1">考勤统计</span>
    <div class="shadow-2"
      style="width: 750px;margin-top: 50px; background-color: white;padding: 70px;box-sizing: border-box;display: flex;flex-direction: column;">
      <div style="display: flex;flex-direction: row;">
        <div style="text-align: left;box-sizing: border-box;">
          <span class="mentText">考勤统计范围：</span>
          <el-date-picker v-model="stime" type="date" value-format='yyyy-MM-dd' placeholder="选择日期" />
          到
          <el-date-picker v-model="etime" type="date" value-format='yyyy-MM-dd' placeholder="选择日期" />
        </div>
      </div>
      <div style="margin-top: 20px;text-align: left;box-sizing: border-box;">
        <span class="mentText">早上签到时间：</span>
        <el-time-select v-model="morning.stime" :picker-options="{ start: '06:00', step: '00:01', end: '12:00'}"
          placeholder="开始时间" />
        到
        <el-time-select v-model="morning.etime" :picker-options="{ start: '06:00', step: '00:01', end: '12:00'}"
          placeholder="结束时间" />
      </div>
      <div style="margin-top: 20px;text-align: left;box-sizing: border-box;">
        <span class="mentText">下午签到时间：</span>
        <el-time-select v-model="afternoon.stime" :picker-options="{ start: '12:00', step: '00:01', end: '18:00'}"
          placeholder="开始时间" />
        到
        <el-time-select v-model="afternoon.etime" :picker-options="{ start: '12:00', step: '00:01', end: '18:00'}"
          placeholder="结束时间" />
      </div>
      <el-button type="primary" style="align-self: flex-end;margin-top: 10px;" @click="submit">统计</el-button>
    </div>

    <div v-if="list.length>0" class="tableTitle">考勤结果</div>

    <div class="tableTitle" v-if="list.length>0">
      <div :class="{'lei-select':thisSelect=='考勤统计','lei':true}" @click="thisSelect='考勤统计'">考勤统计</div>
      <div :class="{'lei-select':thisSelect=='未签到明细','lei':true}" @click="thisSelect='未签到明细'">未签到明细</div>
    </div>
    <table class="table" v-if="list.length>0 && thisSelect == '考勤统计'">
      <tr>
        <th>部门</th>
        <!-- <th>岗位</th> -->
        <th>姓名</th>
        <th>应签天数</th>
        <th>有效签到</th>
        <th>请（休）假</th>
        <th>下乡/出差</th>
        <th>缺勤</th>
        <th>备注</th>
      </tr>
      <tr v-for="(item,index) in list" :key="index">
        <td width="110">{{item["部门"]}}</td>
        <!-- <td width="80">{{item["岗位"]}}</td> -->
        <td width="60">{{item["姓名"]}}</td>
        <td width="60">{{item["应签天数"]}}</td>
        <td width="60">{{item["有效签到"]}}</td>
        <td width="80"></td>
        <td width="60"></td>
        <td width="60"></td>
        <td width="60"></td>
      </tr>
    </table>

    <table class="table" v-if="list1.length>0 && thisSelect == '未签到明细'">
      <tr>
        <th>部门</th>
        <th>姓名</th>
        <th>日期</th>
        <th>早上</th>
        <th>下午</th>
      </tr>
      <tr v-for="(item,index) in list1" :key="index">
        <td width="110">{{item.department}}</td>
        <td width="110">{{item.NAME}}</td>
        <td width="110">{{item.sign_date}}</td>
        <td width="110">{{item.swyxqd}}</td>
        <td width="110">{{item.xwyxqd}}</td>
      </tr>
    </table>

  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        thisSelect: '考勤统计',
        list: [], //考勤统计
        list1: [], //未签到明细
        ying: '', //应该签到的天数。次数再*2
        stime: '',
        etime: '',
        morning: {
          stime: '',
          etime: ''
        },
        afternoon: {
          stime: '',
          etime: ''
        }
      }
    },
    methods: {
      //获取早上和下午的签到起始时间
      getLoginTimes() {
        let curr = this;
        axios({
            method: 'post',
            url: curr.appURL + '/renli.php',
            data: {
              token: localStorage.token,
              type: 'getLoginTimes'
            },
          })
          .then(res => {
            if (res.data.code == 0) {
              for (let s of res.data.result) {
                if (s.type == '早上') {
                  curr.morning.stime = s.stime.substr(0, 5);
                  curr.morning.etime = s.etime.substr(0, 5);
                }
                if (s.type == '下午') {
                  curr.afternoon.stime = s.stime.substr(0, 5);
                  curr.afternoon.etime = s.etime.substr(0, 5);
                }
              }
            }
          });
      },
      //考勤统计
      submit() {
        let curr = this;
        curr.list = [];
        curr.ying = '';
        axios({
            method: 'post',
            url: curr.appURL + '/renli.php',
            data: {
              token: localStorage.token,
              type: 'attendanceStatistics',
              stime: curr.stime,
              etime: curr.etime,
              morningStime: curr.morning.stime,
              morningEtime: curr.morning.etime,
              afternoonStime: curr.afternoon.stime,
              afternoonEtime: curr.afternoon.etime
            },
          })
          .then(res => {
            console.log(res);
            if (res.data.code == 0) {
              curr.list = res.data.result;
              curr.ying = res.data.ying;
            }
          });

        //计算未签到记录
        axios({
            method: 'post',
            url: curr.appURL + '/renli.php',
            data: {
              token: localStorage.token,
              type: 'notSigningList',
              stime: curr.stime,
              etime: curr.etime,
              morningStime: curr.morning.stime,
              morningEtime: curr.morning.etime,
              afternoonStime: curr.afternoon.stime,
              afternoonEtime: curr.afternoon.etime
            },
          })
          .then(res => {
            console.log(res);
            if (res.data.code == 0) {
              curr.list1 = res.data.result;
            }
          });
      }
    },
    created() {
      this.getLoginTimes(); //获取早上和下午的签到起始时间
      this.stime = this.getFirstDayOfMonth(new Date());
      this.etime = this.getEndDayOfMonth(new Date());
    }

  }
</script>

<style scoped>
  .titleMent1 {
    font-size: 30px;
    font-weight: bold;
    margin-top: 50px;
  }

  .mentText {
    color: #888;
    font-weight: bold;
  }

  .tableTitle {
    width: 750px;
    display: flex;
    flex-direction: row;
    align-items: center;

  }

  .lei {
    cursor: pointer;
    font-weight: 300;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 40px;
    background-color: #d1ece0;
    border: 1px dashed #61C699;
  }

  .lei:nth-of-type(n+2) {
    margin-left: 15px;
  }

  .lei:hover {
    background-color: #61C699;
    color: white;
  }


  .lei-select {
    background-color: #61C699;
    border: 1px solid #61C699;
    color: white;
  }

  .lei-noSelect {}

  .table {
    border-collapse: collapse;
    border: none;
    background-color: white;
    width: 750px;
    margin-top: 25px;
    margin-bottom: 100px;
  }

  .table tr {
    height: 38px;
  }

  .table tr th {
    color: white;
    background-color: rgba(97, 198, 153, 1);
    height: 40px;
  }

  .table td {
    /* height: 36px; */
    border: dashed #ccc 1px;
  }

  .red {
    color: red;
  }

  .tableTitle {
    margin-top: 30px;
    font-size: 22px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/view/homePage/homePage.vue